<template>
  <div>
    <span :class="`${number ? 'has-tip' : ''}`" :data-title="tooltip">{{ number || '-' }}</span>
  </div>
</template>

<script>
export default {
  computed: {
    extraAttributes() {
      return this.config?.extraAttributes || {}
    },
    row() {
      return this.config?.row || {}
    },
    item() {
      return this.row?.[this.config?.key] || {}
    },
    number() {
      return this.$util.reduce(this.item, ({ item, next }) => {
        return (next += item.number)
      })
    },
    tooltip() {
      return `<div class="design-idea-statistic-tooltip">${Object.values(
        this.$util.map(this.item, ({ item }) => {
          return `<div><label class="m-0">${item.name}</label>: <span>${item.number}</span></div>`
        })
      ).join('')}</div>`
    }
  },
  props: {
    config: Object
  },
  methods: {}
}
</script>

<style lang="scss">
.design-idea-statistic-tooltip {
  font-size: 12px;
}
</style>
